// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"4329e639","247":"7f9d64db","513":"ba44ebd0","706":"711ede07","726":"2b58ec26","991":"7a46d33e"}[chunkId] + ".chunk.js";
};